var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":30,"width":30},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }